"use strict";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = exports.QuantityPicker = void 0;
var _react = require("@floating-ui/react");
var _icons = require("@ori-ui/icons");
var _material = require("@ori-ui/mui-bundle/material");
var _clsx = _interopRequireDefault(require("clsx"));
var _react2 = require("react");
var _utils = require("../utils");
var _constants = require("./constants");
var _quantityPickerStyled = require("./quantityPickerStyled");
var _useDebug = require("./useDebug");
var _useQuantityPicker = require("./useQuantityPicker");
var _useVisualProps = require("./useVisualProps");
var _jsxRuntime = require("react/jsx-runtime");
var QuantityPicker = exports.QuantityPicker = /*#__PURE__*/ (0, _react2.forwardRef)(function(inProps, ref) {
    var props = (0, _material.useThemeProps)({
        props: inProps,
        name: 'MuiOriQuantityPicker'
    });
    var className = props.className, _props_component = props.component, component = _props_component === void 0 ? 'div' : _props_component, _props_DecreaseIconButtonProps = props.DecreaseIconButtonProps, DecreaseIconButtonProps = _props_DecreaseIconButtonProps === void 0 ? {} : _props_DecreaseIconButtonProps, _props_disabled = props.disabled, disabled = _props_disabled === void 0 ? false : _props_disabled, expanded = props.expanded, _props_expandOnFocus = props.expandOnFocus, expandOnFocus = _props_expandOnFocus === void 0 ? false : _props_expandOnFocus, height = props.height, _props_IncreaseIconButtonProps = props.IncreaseIconButtonProps, IncreaseIconButtonProps = _props_IncreaseIconButtonProps === void 0 ? {} : _props_IncreaseIconButtonProps, tmp = props.InputProps, InputBaseProps = tmp === void 0 ? {} : tmp, _props_labelsTranslations = props.labelsTranslations, labelsTranslations = _props_labelsTranslations === void 0 ? {} : _props_labelsTranslations, onChange = props.onChange, onClickAway = props.onClickAway, onFocus = props.onFocus, _props_minValue = props.minValue, minValue = _props_minValue === void 0 ? _constants.DEFAULT_MIN_VALUE : _props_minValue, _props_readOnly = props.readOnly, readOnly = _props_readOnly === void 0 ? false : _props_readOnly, required = props.required, _props_size = props.size, size = _props_size === void 0 ? 'medium' : _props_size, tooltipMaxText = props.tooltipMaxText, _props_variant = props.variant, variant = _props_variant === void 0 ? 'contained' : _props_variant, width = props.width, _props_maxValue = props.maxValue, maxValue = _props_maxValue === void 0 ? _constants.DEFAULT_MAX_VALUE : _props_maxValue, _props_maxGroupValue = props.maxGroupValue, maxGroupValue = _props_maxGroupValue === void 0 ? maxValue : _props_maxGroupValue, _props_tooltipMaxDisabled = props.tooltipMaxDisabled, tooltipMaxDisabled = _props_tooltipMaxDisabled === void 0 ? false : _props_tooltipMaxDisabled, otherProps = _object_without_properties(props, [
        "className",
        "component",
        "DecreaseIconButtonProps",
        "disabled",
        "expanded",
        "expandOnFocus",
        "height",
        "IncreaseIconButtonProps",
        "InputProps",
        "labelsTranslations",
        "onChange",
        "onClickAway",
        "onFocus",
        "minValue",
        "readOnly",
        "required",
        "size",
        "tooltipMaxText",
        "variant",
        "width",
        "maxValue",
        "maxGroupValue",
        "tooltipMaxDisabled"
    ]);
    var _ref = _sliced_to_array((0, _react2.useState)(expanded !== null && expanded !== void 0 ? expanded : false), 2), focused = _ref[0], setFocused = _ref[1];
    var _ref1 = (0, _useQuantityPicker.useQuantityPicker)(props), groupValue = _ref1.groupValue, handleBlur = _ref1.handleBlur, handleChange = _ref1.handleChange, handleKeyDown = _ref1.handleKeyDown, id = _ref1.id, InputProps = _ref1.InputProps, lastIncreased = _ref1.lastIncreased, logBase = _ref1.logBase, onDecrease = _ref1.onDecrease, onIncrease = _ref1.onIncrease, value = _ref1.value;
    var log = (0, _useDebug.useDebug)("ID-".concat(id)).log;
    var _ref2 = (0, _useVisualProps.useVisualProps)(props), cssProps = _ref2.cssProps, buttonProps = _ref2.buttonProps;
    var ownerState = _object_spread_props(_object_spread({}, props), {
        cssProps: cssProps,
        disabled: disabled,
        expandOnFocus: expandOnFocus,
        focused: focused,
        readOnly: readOnly,
        size: size,
        variant: variant
    });
    (0, _react2.useEffect)(function() {
        if (typeof expanded === 'boolean') {
            setFocused(expanded);
        }
    }, [
        expanded
    ]);
    var handleClickAway = (0, _react2.useCallback)(function() {
        if (typeof expanded === 'boolean') {
            return;
        }
        setFocused(false);
    }, [
        expanded
    ]);
    var handleFocus = (0, _react2.useCallback)(function() {
        if (typeof expanded === 'boolean') {
            return;
        }
        setFocused(true);
    }, [
        expanded
    ]);
    var handleFocusForked = (0, _utils.useForkCallback)(handleFocus, onFocus);
    var handleClickAwayForked = (0, _utils.useForkCallback)(handleClickAway, onClickAway);
    var classes = (0, _quantityPickerStyled.useUtilityClasses)(ownerState);
    var inputRef = (0, _react2.useRef)(null);
    var _ref3 = _sliced_to_array((0, _react2.useState)(false), 2), tooltipMaxOpen = _ref3[0], setTooltipMaxOpen = _ref3[1];
    var arrowRef = (0, _react2.useRef)(null);
    var _ref4 = (0, _react.useFloating)({
        open: tooltipMaxOpen,
        onOpenChange: setTooltipMaxOpen,
        placement: 'top-end',
        strategy: 'absolute',
        middleware: [
            (0, _react.offset)({
                mainAxis: 15,
                alignmentAxis: -10
            }),
            (0, _react.shift)(),
            (0, _react.flip)(),
            (0, _react.size)({
                apply: function(param) {
                    var elements = param.elements;
                    Object.assign(elements.floating.style, {
                        maxWidth: "calc(".concat(cssProps.holder.width, " - 10px)")
                    });
                }
            }),
            (0, _react.arrow)({
                element: arrowRef
            })
        ],
        whileElementsMounted: _react.autoUpdate
    }), _ref_refs = _ref4.refs, setReference = _ref_refs.setReference, setFloating = _ref_refs.setFloating, floatingStyles = _ref4.floatingStyles, context = _ref4.context;
    var maxReached = (0, _react2.useMemo)(function() {
        var max = Math.min(maxValue, maxGroupValue);
        return value >= max || groupValue >= maxGroupValue;
    }, [
        groupValue,
        maxGroupValue,
        maxValue,
        value
    ]);
    var dismiss = (0, _react.useDismiss)(context);
    var role = (0, _react.useRole)(context, {
        role: 'alertdialog'
    });
    var getFloatingProps = (0, _react.useInteractions)([
        dismiss,
        role
    ]).getFloatingProps;
    var _ref5 = (0, _react.useTransitionStyles)(context, {
        initial: {
            opacity: 0,
            transform: 'scale(0.8)'
        }
    }), transitionStyles = _ref5.styles;
    var isTooltipMaxUsable = (0, _react2.useMemo)(function() {
        if (!tooltipMaxDisabled && typeof tooltipMaxText === 'string' && Boolean(tooltipMaxText) && maxValue < _constants.DEFAULT_MAX_VALUE) {
            return true;
        }
        return false;
    }, [
        maxValue,
        tooltipMaxDisabled,
        tooltipMaxText
    ]);
    (0, _react2.useEffect)(function() {
        setTooltipMaxOpen(maxReached && lastIncreased === id);
    }, [
        id,
        lastIncreased,
        maxReached
    ]);
    var showTooltip = (0, _react2.useCallback)(function() {
        setTooltipMaxOpen(true);
    }, []);
    // INFO 2025-06-30 this is debug to console part that will go away in next major release
    var logMax = (0, _react2.useMemo)(function() {
        var newLine = '\r\n ';
        var values = "value / maxValue:  ".concat(value, " / ").concat(maxValue);
        var groups = "➖ groupValue / maxGroupValue:  ".concat(groupValue, " / ").concat(maxGroupValue);
        var max = maxReached ? '🔝MAX IS REACHED' : '';
        var tooltip = isTooltipMaxUsable ? tooltipMaxOpen ? ' 🪧 tooltip is opened' : '' : ' ⚠️ tooltip is not usable';
        return [
            newLine,
            values,
            groups,
            newLine,
            max,
            tooltip
        ];
    }, [
        groupValue,
        isTooltipMaxUsable,
        maxGroupValue,
        maxReached,
        maxValue,
        tooltipMaxOpen,
        value
    ]);
    log.apply(void 0, _to_consumable_array(logBase).concat(_to_consumable_array(logMax)));
    // INFO preparing input props
    var inputProps = InputProps.inputProps, otherInputProps = _object_without_properties(InputProps, [
        "inputProps"
    ]);
    var inputElementProps = (0, _react2.useMemo)(function() {
        var _labelsTranslations_inputLabel;
        return _object_spread({
            'aria-label': (_labelsTranslations_inputLabel = labelsTranslations.inputLabel) !== null && _labelsTranslations_inputLabel !== void 0 ? _labelsTranslations_inputLabel : 'Quantity'
        }, inputProps);
    }, [
        inputProps,
        labelsTranslations.inputLabel
    ]);
    // INFO when we use tooltip then the button is never disabled (will look disabled and have different onClick behavior)
    var increaseDisableState = isTooltipMaxUsable ? false : disabled || value >= maxValue;
    // INFO we need this state multiple times so set it in one place make sense
    var isTooltipActive = isTooltipMaxUsable && (maxReached || disabled);
    // INFO when we use tooltip and we reached the limit then the tooltip is shown on click, otherwise the onIncrease function is called
    var increaseOnClick = isTooltipActive ? showTooltip : onIncrease;
    // INFO when we use tooltip and we reached the requirements for tooltip then we need different button styles
    var increaseOwnerState = isTooltipActive ? _object_spread_props(_object_spread({}, ownerState), {
        tooltipTrigger: true
    }) : ownerState;
    // INFO when we use tooltip the button need to have ref to tooltip
    var increaseRef = (0, _react2.useMemo)(function() {
        return isTooltipMaxUsable ? setReference : undefined;
    }, [
        isTooltipMaxUsable,
        setReference
    ]);
    var _labelsTranslations_decreaseButtonLabel, _labelsTranslations_increaseButtonLabel;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_material.ClickAwayListener, {
        onClickAway: handleClickAwayForked,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_quantityPickerStyled.QuantityPickerRoot, _object_spread_props(_object_spread({}, otherProps), {
            ref: ref,
            ownerState: ownerState,
            className: (0, _clsx.default)(classes.root, className),
            as: component,
            onFocus: handleFocusForked,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(_quantityPickerStyled.IconButtonRoot, _object_spread_props(_object_spread({
                    ownerState: ownerState,
                    disabled: disabled || value <= minValue,
                    className: (0, _clsx.default)(classes.iconButton, classes.decreaseButton),
                    "aria-label": (_labelsTranslations_decreaseButtonLabel = labelsTranslations.decreaseButtonLabel) !== null && _labelsTranslations_decreaseButtonLabel !== void 0 ? _labelsTranslations_decreaseButtonLabel : 'Decrease quantity'
                }, buttonProps, DecreaseIconButtonProps), {
                    onClick: onDecrease,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_icons.Remove, {
                        fontSize: "inherit"
                    })
                })),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(_quantityPickerStyled.InputRoot, _object_spread_props(_object_spread({
                    inputRef: inputRef,
                    ownerState: ownerState,
                    readOnly: readOnly,
                    required: required,
                    value: value,
                    disabled: disabled,
                    className: classes.input
                }, InputBaseProps, otherInputProps), {
                    inputProps: inputElementProps,
                    onChange: handleChange,
                    onBlur: handleBlur,
                    onKeyDown: handleKeyDown
                })),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(_quantityPickerStyled.IconButtonRoot, _object_spread_props(_object_spread({
                    ref: increaseRef,
                    disableFocusRipple: isTooltipActive,
                    disableRipple: isTooltipActive,
                    disableTouchRipple: isTooltipActive,
                    ownerState: increaseOwnerState,
                    disabled: increaseDisableState,
                    className: (0, _clsx.default)(classes.iconButton, classes.increaseButton),
                    "aria-label": (_labelsTranslations_increaseButtonLabel = labelsTranslations.increaseButtonLabel) !== null && _labelsTranslations_increaseButtonLabel !== void 0 ? _labelsTranslations_increaseButtonLabel : 'Increase quantity'
                }, buttonProps, IncreaseIconButtonProps), {
                    onClick: increaseOnClick,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_icons.Add, {
                        fontSize: "inherit"
                    })
                })),
                isTooltipMaxUsable && tooltipMaxOpen ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", _object_spread_props(_object_spread({
                    ref: setFloating,
                    style: _object_spread_props(_object_spread({}, floatingStyles), {
                        zIndex: 1
                    })
                }, getFloatingProps()), {
                    "aria-labelledby": "max-value-tooltip-content",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_quantityPickerStyled.TooltipContainer, {
                        style: transitionStyles,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_quantityPickerStyled.TooltipArrow, {
                                ref: arrowRef,
                                tipRadius: 2,
                                height: 8,
                                context: context
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                id: "max-value-tooltip-content",
                                children: tooltipMaxText
                            })
                        ]
                    })
                })) : null
            ]
        }))
    });
});
var _default = exports.default = QuantityPicker; //# sourceMappingURL=QuantityPicker.js.map
